<!--Header-->
<div class="modal-header">
  <div class="modal-title">
    <h4>{{ question }}</h4>
  </div>
  <button type="button" class="close-btn" style="margin-left:10px;"(click)="cancelModal()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<!--Body-->
<div
  class="modal-body d-flex flex-column justify-content-center align-items-center py-5"
>
  <div class="d-flex justify-content-center gap-4 w-100 px-4">
    <button
      class="btn modern-btn primary-btn"
      style="min-width: 140px; flex: 1"
      (click)="option1Selected()"
    >
      <i class="fa-solid fa-cart-flatbed me-2"></i> {{ options[0] }}
    </button>

    <button
      class="btn modern-btn secondary-btn"
      style="min-width: 140px; flex: 1"
      (click)="option2Selected()"
    >
      <i class="fa-solid fa-screwdriver-wrench me-2"></i> {{ options[1] }}
    </button>
  </div>
</div>
